module.exports = __webpack_public_path__ + "img/welcome-img.614a3a2c.png";